import request from "@/utils/request";

// 获取区域列表
export function getList() {
  return request({
    url: "/test/zoneInfo/getList",
    method: "get",
  });
}

// 获取区域下全部片区
export function detail(data) {
  return request({
    url: "/test/zoneInfo/detail",
    method: "post",
    data: data,
  });
}

// 新增区域
export function insertOne(data) {
  return request({
    url: "/test/zoneInfo/insertOne",
    method: "post",
    data: data,
  });
}

// 修改区域
export function update(data) {
  return request({
    url: "/test/zoneInfo/update",
    method: "post",
    data: data,
  });
}

//获取区域信息
export function getZoneInfo(zoneId) {
  return request({
    url: `/test/zoneInfo/` + zoneId,
    method: "get",
  });
}

// 区域统计
export function zoneCount() {
  return request({
    url: "/test/zoneInfo/count",
    method: "get"
  });
}

// 新增区域下的片区
export function insertSmallOne(data) {
  return request({
    url: "/test/zoneDetailInfo/insertOne",
    method: "post",
    data: data,
  });
}

// 查看区域下片区详情
export function detailSmall(data) {
  return request({
    url: "/test/zoneDetailInfo/detail",
    method: "post",
    data: data,
  });
}

// 修改区域下的片区
export function editOne(data) {
  return request({
    url: "/test/zoneDetailInfo/editOne",
    method: "post",
    data: data,
  });
}

//查看区域下的所有测试片区
export function getListByZoneId(zoneId) {
  return request({
    url: `/test/zoneDetailInfo/getListByZoneId?zoneId=` + zoneId,
    method: "get",
  });
}

//获取测试区域信息
export function getZoneById(zoneId) {
  return request({
    url: `/test/zoneInfo/getInfoById/` + zoneId,
    method: "get",
  });
}
